(function () {
  'use strict';

var SHADES = [
  { name: 'Ivory',         hex: '#faf2e7', depth: 0, ut: ['cool', 'neutral'] },
  { name: 'Golden Ivory',  hex: '#f9eddd', depth: 0, ut: ['warm', 'neutral'] },
  { name: 'Fair',          hex: '#f7e8d3', depth: 1, ut: ['cool', 'neutral'] },
  { name: 'Fair Golden',   hex: '#f4e4ca', depth: 1, ut: ['warm', 'neutral'] },
  { name: 'Light Golden',  hex: '#f2ddc2', depth: 1, ut: ['warm'] },
  { name: 'Light Honey',   hex: '#efdec0', depth: 2, ut: ['warm'] },
  { name: 'Light Beige',   hex: '#f1d9b7', depth: 2, ut: ['cool', 'neutral'] },
  { name: 'Medium Beige',  hex: '#f1cfac', depth: 3, ut: ['cool', 'neutral'] },
  { name: 'Medium Golden', hex: '#edc999', depth: 3, ut: ['warm'] },
  { name: 'Dark Beige',    hex: '#e9bc93', depth: 4, ut: ['cool', 'neutral'] },
  { name: 'Tan',           hex: '#e2b07f', depth: 4, ut: ['cool', 'neutral'] },
  { name: 'Tan Golden',    hex: '#e2b87c', depth: 4, ut: ['warm'] },
  { name: 'Medium Tan',    hex: '#e2aa6f', depth: 4, ut: ['cool', 'neutral'] },
  { name: 'Light Caramel', hex: '#dfa371', depth: 5, ut: ['warm', 'neutral'] },
  { name: 'Caramel',       hex: '#d6915a', depth: 5, ut: ['warm', 'neutral'] },
  { name: 'Dark Caramel',  hex: '#c57b4a', depth: 5, ut: ['warm', 'neutral'] },
  { name: 'Deep Golden',   hex: '#b26a38', depth: 5, ut: ['warm'] },
  { name: 'Warm Deep',     hex: '#935026', depth: 5, ut: ['warm', 'neutral'] }
];

  var QUESTIONS = [
    { id: 'tone', pct: 16, label: 'How would you describe your skin tone?', hint: 'Choose the description closest to your natural complexion',
      choices: [
        { l: 'Very fair \u2014 porcelain or ivory', v: '0' },
        { l: 'Fair \u2014 light with pink or peachy tones', v: '1' },
        { l: 'Light to medium \u2014 soft beige or sand', v: '2' },
        { l: 'Medium \u2014 warm honey or golden beige', v: '3' },
        { l: 'Tan \u2014 rich caramel or warm brown', v: '4' },
        { l: 'Deep \u2014 dark brown or ebony', v: '5' }
      ]
    },
    { id: 'vein', pct: 33, label: 'What color are the veins on your inner wrist?', hint: 'The most reliable way to identify your undertone',
      choices: [
        { l: 'Blue or purple \u2014 cool undertones', v: 'cool' },
        { l: 'Green \u2014 warm undertones', v: 'warm' },
        { l: 'Blue-green \u2014 somewhere in between', v: 'bluegreen' },
        { l: 'Hard to tell', v: 'hardtotell' }
      ]
    },
    { id: 'jewelry', pct: 50, label: 'Which jewelry tone flatters you most?', hint: 'A great second check for undertone',
      choices: [
        { l: 'Silver or white gold', v: 'cool' },
        { l: 'Gold or rose gold', v: 'warm' },
        { l: 'Both equally flattering', v: 'neutral' }
      ]
    },
    { id: 'skintype', pct: 66, label: 'How would you describe your skin type?', hint: 'Helps us recommend the right formula for you',
      choices: [
        { l: 'Oily \u2014 shine appears throughout the day', v: 'oily' },
        { l: 'Dry \u2014 skin feels tight or flaky', v: 'dry' },
        { l: 'Combination \u2014 oily T-zone, dry elsewhere', v: 'combo' },
        { l: 'Normal \u2014 generally balanced', v: 'normal' },
        { l: 'Sensitive \u2014 reacts easily to products', v: 'sensitive' }
      ]
    },
    { id: 'coverage', pct: 83, label: 'What level of coverage do you prefer?', hint: "Be honest \u2014 there's no wrong answer",
      choices: [
        { l: 'Light \u2014 just a little evening out', v: 'light' },
        { l: 'Medium \u2014 covers most imperfections', v: 'medium' },
        { l: 'Full \u2014 I want everything covered', v: 'full' },
        { l: 'Buildable \u2014 I like to layer as needed', v: 'buildable' }
      ]
    },
    { id: 'concern', pct: 100, label: "What's your main concealer concern?", hint: "We'll tailor your recommendation around this",
      choices: [
        { l: 'Dark circles or under-eye discoloration', v: 'darkcircles' },
        { l: 'Blemishes or acne spots', v: 'blemishes' },
        { l: 'Redness or uneven skin tone', v: 'redness' },
        { l: 'Dark spots or hyperpigmentation', v: 'spots' },
        { l: 'All of the above \u2014 full coverage everywhere', v: 'all' }
      ]
    }
  ];

  var rootEl = document.getElementById('ac-quiz-root');
  if (!rootEl) return;

  var CFG = {
    heading:      rootEl.dataset.heading      || 'Find Your Perfect Shade',
    subheading:   rootEl.dataset.subheading   || 'Tell us about your skin in 6 quick questions and we\u2019ll handle the perfect match (and more).',
    buttonLabel:  rootEl.dataset.buttonLabel  || 'Begin Shade Match',
    productUrl:   rootEl.dataset.productUrl   || 'https://www.amazingcosmetics.com/products/amazingconcealer',
    duoUrl:       rootEl.dataset.duoUrl       || 'https://www.amazingcosmetics.com/products/smooth-creme-concealer-foundation',
    bundleUrl:    rootEl.dataset.bundleUrl    || 'https://www.amazingcosmetics.com/collections/concealers/products/smooth-creme-concealer-foundation-duo-brush-pair',
    acBundleUrl:  rootEl.dataset.acBundleUrl  || 'https://www.amazingcosmetics.com/products/amazing-concealer-and-smooth-blender',
    correctorUrl: rootEl.dataset.correctorUrl || 'https://www.amazingcosmetics.com/products/color-correctors',
    powderUrl:    rootEl.dataset.powderUrl    || 'https://www.amazingcosmetics.com/products/velvet-mineral-powderset',
    concealerImg: rootEl.dataset.concealerImg || 'https://www.amazingcosmetics.com/cdn/shop/files/AMAZINGCONCEALER_a19b8da5-b51b-4b79-9569-37f23ead73cf.jpg?v=1773072573&width=200',
    duoImg:       rootEl.dataset.duoImg       || 'https://www.amazingcosmetics.com/cdn/shop/files/SMOOTH_DUO.jpg?v=1764880674&width=200',
    bundleImg:    rootEl.dataset.bundleImg    || 'https://www.amazingcosmetics.com/cdn/shop/files/SD_FB_Bundle_cd9f49e8-dbd1-4ba2-a602-37f7fa2f5a32.png?v=1772477127&width=200',
    powderImg:    rootEl.dataset.powderImg    || 'https://www.amazingcosmetics.com/cdn/shop/files/VELVET_MINERAL_POWDERSET.jpg?width=200',
    correctorImg: rootEl.dataset.correctorImg || 'https://cdn.shopify.com/s/files/1/0210/9692/files/COLOR_CORRECTORS.png?v=1777324889',
    acBundleImg:  rootEl.dataset.acBundleImg  || 'https://www.amazingcosmetics.com/cdn/shop/files/AMAZINGCONCEALER_a19b8da5-b51b-4b79-9569-37f23ead73cf.jpg?v=1773072573&width=200',
    acPowderBundleUrl: rootEl.dataset.acPowderBundleUrl || 'https://www.amazingcosmetics.com/collections/amazing-bundles/products/amazing-concealer-and-powderset-pair',
    luxuryBrushUrl:    rootEl.dataset.luxuryBrushUrl    || 'https://www.amazingcosmetics.com/collections/amazing-bundles/products/luxury-brush-bundle',
    acPowderBundleImg: rootEl.dataset.acPowderBundleImg || 'https://www.amazingcosmetics.com/cdn/shop/files/AMAZINGCONCEALER_a19b8da5-b51b-4b79-9569-37f23ead73cf.jpg?v=1773072573&width=200',
    luxuryBrushImg:    rootEl.dataset.luxuryBrushImg    || 'https://cdn.shopify.com/s/files/1/0210/9692/files/Essential_Brush_Set.png?v=1777475775',
    welcomeImg:   rootEl.dataset.welcomeImg   || '',
    klaviyoList:  rootEl.dataset.klaviyoList  || '',
    klaviyoKey:   rootEl.dataset.klaviyoKey   || ''
  };

  var SHADE_CARD_VARIANT_ID = 31944900706419;

  var state = { step: 0, answers: {}, emailSubmitted: false };

  function mk(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function dv(cls, html) { var e = mk('div', cls); if (html !== undefined) e.innerHTML = html; return e; }

  function getUndertone() {
    var a = state.answers.vein, b = state.answers.jewelry;
    var va = (a === 'cool') ? 'cool' : (a === 'warm') ? 'warm' : 'neutral';
    var vb = (b === 'cool') ? 'cool' : (b === 'warm') ? 'warm' : 'neutral';
    if (va === 'cool' && vb === 'cool') return 'cool';
    if (va === 'warm' && vb === 'warm') return 'warm';
    if (va === 'cool' || vb === 'cool') return 'cool';
    if (va === 'warm' || vb === 'warm') return 'warm';
    return 'neutral';
  }

  function getMatch() {
  var depth = parseInt(state.answers.tone) || 0;
  var ut = getUndertone();
  var pool = SHADES.filter(function (s) {
    return s.depth === depth && s.ut.indexOf(ut) > -1;
  });

  if (!pool.length) {
    pool = SHADES.filter(function (s) {
      return s.depth === depth;
    });
  }

  var match = pool[0] || SHADES[6];

  // Temporary: Fair is out of stock, so recommend Light Beige instead.
  if (match.name === 'Fair') {
    return SHADES.filter(function (s) {
      return s.name === 'Light Beige';
    })[0];
  }

  return match;
}

  function render() {
    var app = rootEl.querySelector('.ac-app');
    if (!app) { app = dv('ac-app'); rootEl.appendChild(app); }
    app.innerHTML = '';
    if (state.step === 0)                        renderWelcome(app);
    else if (state.step >= 1 && state.step <= 6) renderQuestion(app, state.step - 1);
    else if (state.step === 7)                   renderAnalyzing(app);
    else if (state.step === 8)                   renderEmailGate(app);
    else                                         renderResult(app);
  }

  function logo(app) { app.appendChild(dv('ac-logo', 'AmazingCosmetics')); }

  function renderWelcome(app) {
    app.classList.add('ac-app--welcome');
    var split = dv('ac-welcome-split');
    var imgSide = dv('ac-welcome-img-side');
    if (CFG.welcomeImg) {
      var img = new Image();
      img.src = CFG.welcomeImg;
      img.alt = 'Shade Match Quiz';
      img.className = 'ac-welcome-img';
      imgSide.appendChild(img);
    } else {
      imgSide.appendChild(dv('ac-welcome-placeholder'));
    }
    split.appendChild(imgSide);
    var textSide = dv('ac-welcome-text-side');
    var top = dv('ac-welcome-top');
    top.appendChild(dv('ac-welcome-eyebrow', 'AmazingCosmetics'));
    var hl = dv('ac-welcome-headline');
    hl.innerHTML = 'Find<br>Your<br><em>Perfect</em>Shade';
    top.appendChild(hl);
    top.appendChild(dv('ac-welcome-sub', CFG.subheading));
    var btn = mk('button', 'ac-welcome-btn');
    var arrow = dv('ac-welcome-btn-arrow');
    var label = document.createElement('span');
    label.textContent = CFG.buttonLabel;
    btn.appendChild(arrow);
    btn.appendChild(label);
    btn.onclick = function () {
      app.classList.remove('ac-app--welcome');
      state.step = 1;
      render();
    };
    top.appendChild(btn);
    textSide.appendChild(top);
    var bottom = dv('ac-welcome-bottom');
    bottom.appendChild(dv('ac-welcome-shade-label', 'discover your perfect match'));
    var shadeRow = dv('ac-welcome-shade-row');
    ['#f5e8d5','#f2dfbf','#edd4b8','#e9cda5','#e4c492','#ddb882','#d8ac74','#c49464','#be8c58','#b07a50','#a06c40','#956038','#845030','#724028','#623520'].forEach(function(hex) {
      var dot = document.createElement('div');
      dot.setAttribute('style','width:18px;height:18px;border-radius:50%;display:block;flex-shrink:0;background-color:'+hex+' !important;');
      shadeRow.appendChild(dot);
    });
    bottom.appendChild(shadeRow);
    textSide.appendChild(bottom);
    split.appendChild(textSide);
    app.appendChild(split);
  }

  function renderQuestion(app, idx) {
    var q = QUESTIONS[idx];
    logo(app);
    var pw = dv('ac-progress-wrap');
    pw.innerHTML = '<div class="ac-progress-label">Question ' + (idx + 1) + ' of 6</div><div class="ac-progress-track"><div class="ac-progress-fill" style="width:' + q.pct + '%"></div></div>';
    app.appendChild(pw);
    app.appendChild(dv('ac-question-label', q.label));
    app.appendChild(dv('ac-question-hint', q.hint));
    var opts = dv('ac-options');
    q.choices.forEach(function (c) {
      var isSel = state.answers[q.id] === c.v;
      var btn = mk('button', 'ac-option' + (isSel ? ' selected' : ''));
      var dot = dv('ac-option-dot');
      if (isSel) { dot.style.background = '#df1e87'; dot.style.borderColor = '#df1e87'; }
      btn.appendChild(dot);
      btn.appendChild(document.createTextNode(c.l));
      btn.onclick = function () { state.answers[q.id] = c.v; render(); };
      opts.appendChild(btn);
    });
    app.appendChild(opts);
    var isLast = idx === 5;
    var row = dv('ac-btn-row');
    if (idx > 0) {
      var back = mk('button', 'ac-back-btn');
      back.textContent = '\u2190 Back';
      back.onclick = function () { state.step--; render(); };
      row.appendChild(back);
    }
    var next = mk('button', 'ac-continue-btn');
    next.textContent = isLast ? 'See My Match' : 'Continue';
    if (!state.answers[q.id]) next.disabled = true;
    next.onclick = function () {
      if (isLast) {
        state.step = 7; render();
        setTimeout(function () { state.step = 8; render(); }, 2800);
      } else {
        state.step++; render();
      }
    };
    row.appendChild(next);
    app.appendChild(row);
  }

  function renderAnalyzing(app) {
    logo(app);
    app.appendChild(dv('ac-spinner'));
    var msgs = ['Mapping your shade profile\u2026', 'Analyzing depth and undertone\u2026', 'Finding your perfect match\u2026'];
    var lbl = dv('ac-spinner-label', msgs[0]);
    app.appendChild(lbl);
    var i = 0;
    var iv = setInterval(function () {
      i++; if (i < msgs.length) lbl.textContent = msgs[i]; else clearInterval(iv);
    }, 900);
  }

  function renderEmailGate(app) {
    trackQuizCompletion(getMatch(), state.answers);
    var m = getMatch();
    logo(app);

    var card = dv('ac-email-card');

    var teaser = dv('ac-email-teaser');
    var tsw = document.createElement('div');
    tsw.setAttribute('style','width:56px;height:56px;border-radius:50%;flex-shrink:0;background-color:'+m.hex+' !important;border:3px solid #fff;outline:1px solid #e8d5df;display:block;');
    var tinfo = dv('');
    tinfo.innerHTML = '<div class="ac-email-teaser-eyebrow">Your shade match</div><div class="ac-email-teaser-name">'+m.name+'</div>';
    teaser.appendChild(tsw);
    teaser.appendChild(tinfo);
    card.appendChild(teaser);

    var eyebrow = dv('ac-email-eyebrow', 'Exclusive Offer');
    eyebrow.style.marginTop = '1.25rem';
    card.appendChild(eyebrow);
    var headline = dv('ac-email-headline');
    headline.innerHTML = 'Your match is ready.<br>Claim your 30% off.';
    card.appendChild(headline);
    card.appendChild(dv('ac-email-sub', 'Enter your email to unlock your full shade results and receive your personal discount code.'));

    var row = dv('ac-email-row');
    var inp = mk('input', 'ac-email-input');
    inp.type = 'email';
    inp.placeholder = 'Your email address';
    var submitBtn = mk('button', 'ac-email-submit');
    submitBtn.textContent = 'Unlock My Results';
    row.appendChild(inp);
    row.appendChild(submitBtn);
    card.appendChild(row);

    var err = dv('ac-email-error');
    card.appendChild(err);

    var skip = mk('button', 'ac-email-skip');
    skip.textContent = 'No thanks, skip discount';
    skip.onclick = function () { state.step = 9; render(); };
    card.appendChild(skip);

    card.appendChild(dv('ac-email-note', 'One email. No spam. Unsubscribe anytime.'));

    submitBtn.onclick = function () {
      var email = inp.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        err.textContent = 'Please enter a valid email address.';
        return;
      }
      err.textContent = '';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending\u2026';
      subscribeKlaviyo(email, m.name, function () {
        state.emailSubmitted = true;
        card.innerHTML = '';

        var successTeaser = dv('ac-email-teaser');
        var stw = document.createElement('div');
        stw.setAttribute('style','width:56px;height:56px;border-radius:50%;flex-shrink:0;background-color:'+m.hex+' !important;border:3px solid #fff;outline:1px solid #e8d5df;display:block;');
        var si = dv('');
        si.innerHTML = '<div class="ac-email-teaser-eyebrow">Your shade match</div><div class="ac-email-teaser-name">'+m.name+'</div>';
        successTeaser.appendChild(stw);
        successTeaser.appendChild(si);
        card.appendChild(successTeaser);

        var successBody = dv('ac-email-success');
        successBody.innerHTML =
          '<div class="ac-email-success-headline">Thanks for subscribing!</div>' +
          '<div class="ac-email-success-sub">Check your email for your code. We\'ll also show it on the next page!</div>';
        card.appendChild(successBody);

        setTimeout(function () { state.step = 9; render(); }, 2500);
      });
    };

    app.appendChild(card);
  }

  function renderResult(app) {
    var m = getMatch();
    var skin = state.answers.skintype || 'normal';
    var cov = state.answers.coverage || 'full';
    var concern = state.answers.concern || 'all';
    var depth = parseInt(state.answers.tone) || 0;
    var isOily = (skin === 'oily' || skin === 'combo');
    var primaryIsDuo = (skin === 'dry' || cov === 'light' || cov === 'medium');

    logo(app);

    if (state.emailSubmitted) {
      var codeBanner = dv('ac-code-banner');
      codeBanner.innerHTML =
        '<div class="ac-code-banner-text">Your 30% discount code</div>' +
        '<div class="ac-code-banner-code">MYSHADE30</div>' +
        '<div class="ac-code-banner-note">Apply at checkout on your matched shade and full routine.</div>';
      app.appendChild(codeBanner);
    }

    var hero = dv('ac-match-hero');
    var sw = document.createElement('div');
    sw.className = 'ac-match-swatch';
    sw.setAttribute('style','background-color:'+m.hex+' !important;width:84px;height:84px;border-radius:50%;flex-shrink:0;border:3px solid #fff;outline:1px solid #e8d5df;display:block;');
    var info = dv('');
    info.innerHTML = '<div class="ac-match-eyebrow">Your Shade Match</div><div class="ac-match-name">'+m.name+'</div><div class="ac-match-badge">Best Match</div>';
    hero.appendChild(sw);
    hero.appendChild(info);
    app.appendChild(hero);

    app.appendChild(dv('ac-section-label', 'You may also like'));
    var ar = dv('ac-alt-row');
    SHADES.filter(function (s) { return s !== m && Math.abs(s.depth - depth) <= 1; })
      .slice(0, 2)
      .forEach(function (s, i) {
        var item = dv('ac-alt-item' + (i === 0 ? ' active' : ''));
        var dot = document.createElement('div');
        dot.className = 'ac-alt-dot';
        dot.title = s.name;
        dot.setAttribute('style','background-color:'+s.hex+' !important;width:52px;height:52px;min-width:52px;min-height:52px;border-radius:50%;display:block;flex-shrink:0;border:2.5px solid transparent;transition:border-color .2s;');
        var parts = s.name.split(' ');
        item.appendChild(dot);
        item.appendChild(dv('ac-alt-label', parts[0] + (parts.length > 1 ? '<br>' + parts.slice(1).join(' ') : '')));
        ar.appendChild(item);
      });
    app.appendChild(ar);

    app.appendChild(dv('ac-divider'));
    app.appendChild(dv('ac-section-label', 'Recommended for you'));

    var picks = [];
    var useAcPowderBundle = (!primaryIsDuo && cov === 'full' && isOily);
    var wantsCorrector = (cov === 'full' || concern === 'all' || concern === 'darkcircles');

    if (useAcPowderBundle) {
      picks.push({
        name: 'AMAZINGCONCEALER & Powderset Bundle',
        shade: true,
        desc: 'Your full-coverage AMAZINGCONCEALER shade paired with Velvet Mineral Powderset to set makeup and control shine.',
        price: '$49 (save $12)',
        img: CFG.acPowderBundleImg,
        url: CFG.acPowderBundleUrl
      });
    } else if (primaryIsDuo) {
      picks.push({
        name: 'SMOOTH\u00ae Cr\u00e8me Concealer & Foundation Duo',
        shade: true,
        desc: 'Hydrating all-over foundation + concentrated concealer in one flip-cap product.',
        price: '$40',
        img: CFG.duoImg,
        url: CFG.duoUrl
      });
    } else {
      picks.push({
        name: 'AMAZINGCONCEALER',
        shade: true,
        desc: 'Ultra-concentrated, water-resistant, full coverage. Enriched with cucumber extract. Lasts 9\u201318 months.',
        price: '$32',
        img: CFG.concealerImg,
        url: CFG.productUrl
      });
    }

    if (isOily && !useAcPowderBundle) {
      picks.push({
        name: 'Velvet Mineral Powderset',
        shade: false,
        desc: 'One shade fits all. Sets makeup, minimizes pores, and controls shine all day.',
        price: '$29',
        img: CFG.powderImg,
        url: CFG.powderUrl
      });
    }

    if (primaryIsDuo) {
      picks.push({
        name: 'Luxury Brush Set',
        shade: false,
        desc: 'A complete brush set to blend, buff, and perfect your SMOOTH\u00ae Duo routine.',
        price: '$35 ($71 value)',
        img: CFG.luxuryBrushImg,
        url: CFG.luxuryBrushUrl
      });
    }

    if (wantsCorrector && picks.length < 3) {
      picks.push({
        name: 'Color Correctors',
        shade: false,
        desc: 'Neutralize dark circles, redness & dark spots before concealing for a flawless finish.',
        price: '$32',
        img: CFG.correctorImg,
        url: CFG.correctorUrl,
        isCc: !CFG.correctorImg
      });
    }

    if (!primaryIsDuo && !useAcPowderBundle && picks.length < 3) {
      picks.push({
        name: 'AMAZINGCONCEALER & Concealer Brush Bundle',
        shade: true,
        desc: 'Your matched AMAZINGCONCEALER paired with our precision concealer brush \u2014 best value.',
        price: '$35 (save $12)',
        img: CFG.acBundleImg,
        url: CFG.acBundleUrl
      });
    }

    picks.slice(0, 3).forEach(function (p) {
      var card = dv('ac-product-card');
      var imgWrap = dv('ac-product-image');
      if (p.isCc) {
        var ccDot = dv('ac-product-swatch'); ccDot.style.background = 'linear-gradient(135deg, #f4a460 50%, #90ee90 50%)'; imgWrap.appendChild(ccDot);
      } else if (p.img) {
        var img = new Image(); img.alt = p.name; img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block'; img.src = p.img; imgWrap.appendChild(img);
      } else {
        var fallDot = dv('ac-product-swatch'); fallDot.style.background = m.hex; imgWrap.appendChild(fallDot);
      }
      var det = dv('ac-product-detail');
      det.appendChild(dv('ac-product-name', p.name + (p.shade ? ' \u2014 ' + m.name : '')));
      det.appendChild(dv('ac-product-desc', p.desc));
      var foot = dv('ac-product-footer');
      foot.appendChild(dv('ac-product-price', p.price));
      var shopBtn = mk('button', 'ac-shop-now');
      shopBtn.textContent = 'Shop now';
      (function (url) { shopBtn.onclick = function () { window.open(url, '_blank'); }; })(p.url);
      foot.appendChild(shopBtn);
      det.appendChild(foot);
      card.appendChild(imgWrap);
      card.appendChild(det);
      app.appendChild(card);
    });

    // Expert tip
    app.appendChild(dv('ac-divider'));
    app.appendChild(dv('ac-section-label', 'Expert tip'));
    app.appendChild(dv('ac-tip-box', getTip(skin, concern)));

    // Shade card section
    app.appendChild(dv('ac-divider'));
    app.appendChild(renderShadeCard());

    var shopCta = mk('button', 'ac-start-btn');
    shopCta.textContent = 'Shop My Shade';
    shopCta.style.marginTop = '1rem';
    shopCta.onclick = function () { window.open(primaryIsDuo ? CFG.duoUrl : CFG.productUrl, '_blank'); };
    app.appendChild(shopCta);

    var retakeBtn = mk('button', 'ac-ghost-btn');
    retakeBtn.textContent = 'Retake the quiz';
    retakeBtn.onclick = function () { state = { step: 0, answers: {}, emailSubmitted: false }; render(); };
    app.appendChild(retakeBtn);
  }

  function renderShadeCard() {
    var section = dv('ac-shade-card');

    var imgWrap = dv('ac-shade-card-img');
    var img = new Image();
    img.src = 'https://cdn.shopify.com/s/files/1/0210/9692/files/Shade_Card_Model.png';
    img.alt = 'Model holding AMAZINGCOSMETICS shade card';
    imgWrap.appendChild(img);

    var body = dv('ac-shade-card-body');
    body.appendChild(dv('ac-shade-card-eyebrow', 'Still not sure?'));

    var hl = mk('h3', 'ac-shade-card-headline');
    hl.textContent = 'Get A Free Shade Card';
    body.appendChild(hl);

    body.appendChild(dv('ac-shade-card-desc', 'Hold real swatches to your chin line and find your match before you commit.'));

    var badge = dv('ac-shade-card-badge');
    badge.innerHTML = 'Use code <span class="ac-shade-card-code">SHADECARD</span> at checkout';
    body.appendChild(badge);

    var btn = mk('button', 'ac-shade-card-btn');
    btn.id = 'ac-sc-btn';
    btn.textContent = 'ADD TO CART';
    btn.onclick = function () { addShadeCardToCart(btn); };
    body.appendChild(btn);

    var success = dv('ac-shade-card-success');
    success.id = 'ac-sc-success';
    success.innerHTML = '<span class="ac-shade-card-check"><svg viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2.5"><polyline points="2,6 5,9 10,3"/></svg></span>Added! Use <strong>SHADECARD</strong> at checkout';
    body.appendChild(success);

    body.appendChild(dv('ac-shade-card-fine', 'SHIPS FREE'));

    section.appendChild(imgWrap);
    section.appendChild(body);
    return section;
  }

  function addShadeCardToCart(btn) {
    btn.textContent = 'Adding\u2026';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: SHADE_CARD_VARIANT_ID, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.style.display = 'none';
      var success = document.getElementById('ac-sc-success');
      if (success) success.style.display = 'flex';
    })
    .catch(function () {
      btn.textContent = 'Add to cart \u2014 free';
      btn.disabled = false;
    });
  }

  function subscribeKlaviyo(email, shade, cb) {
    if (!CFG.klaviyoList || !CFG.klaviyoKey) {
      console.log('[ShadeMatchQuiz] Klaviyo not configured.'); cb(false); return;
    }
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CFG.klaviyoKey, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
      body: JSON.stringify({
        data: { type: 'subscription', attributes: {
          list_id: CFG.klaviyoList, email: email,
          custom_source: 'Shade Match Quiz',
          properties: { shade_match: shade, discount_code: 'MYSHADE30', quiz_email_captured: true }
        }}
      })
    }).then(function (r) { cb(r.ok); }).catch(function () { cb(false); });
  }

  function getTip(skin, concern) {
    var base = {
      oily:      '<b>For oily skin:</b> Apply in pin-dot amounts and tap \u2014 never drag. Set with the Velvet Mineral Powderset to lock in all-day wear.',
      dry:       '<b>For dry skin:</b> Warm the product between fingertips first. The creamy formula won\u2019t cling to dry patches for a smooth finish.',
      combo:     '<b>For combination skin:</b> Use pin-dot amounts and blend outward. Set with powder only on your T-zone.',
      sensitive: '<b>For sensitive skin:</b> AMAZINGCONCEALER is dermatologist-tested, paraben-free, and gluten-free. Apply gently with a clean brush.',
      normal:    '<b>Pro tip:</b> A little goes a very long way. Start with one pin-dot and tap to blend \u2014 never rub.'
    };
    var extra = {
      darkcircles: ' Apply a Color Corrector first to neutralize blue-purple under-eye tones before layering your shade on top.',
      redness:     ' Stipple your shade over red areas \u2014 avoid rubbing \u2014 to prevent spreading irritation.',
      spots:       ' A peach Color Corrector underneath dramatically reduces dark spot visibility before concealing.',
      blemishes:   ' Apply after moisturizer has absorbed. Use the tip applicator directly on the spot for precision.',
      all:         ''
    };
    return (base[skin] || base.normal) + (extra[concern] || '');
  }

  render();

  function trackQuizCompletion(match, answers) {
    var PUBLIC_KEY = 'Qubitt';
    var anonId = sessionStorage.getItem('ac_quiz_anon_id');
    if (!anonId) {
      anonId = 'anon_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('ac_quiz_anon_id', anonId);
    }
    fetch('https://ipapi.co/json/')
      .then(function(r) { return r.json(); })
      .catch(function() { return {}; })
      .then(function(geo) {
        fetch('https://a.klaviyo.com/client/profiles/?company_id=' + PUBLIC_KEY, {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
          body: JSON.stringify({
            data: { type: 'profile', attributes: {
              anonymous_id: anonId,
              properties: {
                quiz_completed: true,
                quiz_completed_at: new Date().toISOString(),
                quiz_shade_match: match.name,
                quiz_shade_depth: match.depth,
                quiz_undertone: getUndertone(),
                quiz_skin_type: answers.skintype || 'unknown',
                quiz_coverage: answers.coverage || 'unknown',
                quiz_concern: answers.concern || 'unknown',
                quiz_country: geo.country_name || 'unknown',
                quiz_country_code: geo.country_code || 'unknown'
              }
            }}
          })
        }).catch(function() {});
      });
  }

})();